import {Injectable} from '@angular/core';
import {createInitialState, userInfoStore} from './user-info.store';
import {UserInfoState, UserStatus} from './user-info.type';
import {setProps} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class UserInfoManager {
  public setUserInfo(value: UserInfoState) {
    userInfoStore.update(setProps({userInfo: value}));
  }

  public resetAndLogout() {
    userInfoStore.reset();
    userInfoStore.update(setProps({userInfo: {...createInitialState(), userStatus: UserStatus.LoggedOut}}));
  }
}
